var MemberContextMenuView = require('membercontextmenuview');
var ChannelContextMenuView = require('channelcontextmenuview');
var ConversationContextMenuView = require('conversationcontextmenuview');
var ServerLogContextMenuView = require('serverlogcontextmenuview');
var UploadContextMenuView = require('uploadcontextmenuview');
var EmojiContextMenuView = require('emojicontextmenuview');
var EnterpriseJoinView = require('enterprisejoinview');
var FaviconView = require('faviconview');
var HashDialogView = require('hashdialogview');
var StatusView = require('statusview');
var IRCCloudNotifier = require('irccloudnotifier');
var InvitesDialogView = require('invitesdialogview');
var JoinDefaultView = require('joindefaultview');
var MainAreaView = require('mainareaview');
var NickservView = require('nickservview');
var ConnectionTokenView = require('connectiontokenview');
var EmailBounceView = require('emailbounceview');
var OrgsDialogView = require('orgsdialogview');
var Overlay = require('overlay');
var PastebinDialogView = require('pastebindialogview');
var FileUploadDialogView = require('fileuploaddialogview');
var LogDownloadDialogView = require('logdownloaddialogview');
var ShortcutsDialogView = require('shortcutsdialogview');
var FileWrapper = require('filewrapper');
var FilesDialogView = require('filesdialogview');
var PastebinsDialogView = require('pastebinsdialogview');
var SidebarView = require('sidebarview');
var TitleView = require('titleview');
var UpgradeView = require('upgradeview');
var VerifyNoticeView = require('verifynoticeview');
var NoAuthDialogView = require('noauthdialogview');
var Keyboard = require('../lib/keyboard.es6').default;
var ChannelSwitcher = require('./channel-switch-dialog.es6').default;
var AvatarUploadDialog = require('./avatar-upload-dialog.es6').default;
var AvatarChooserDialog = require('./avatar-chooser-dialog.es6').default;
var AvatarUploadView = require('avataruploadview');
var AddSlackView = require('./addslackview.es6').default;
var util = require('../lib/util.es6');
var atPoint = require('atpoint');


var SessionView = Backbone.View.extend({
    el: 'body',
    initialize: function (options) {
        _.bindAll(this,
            'windowBlur', 'windowFocus', 'initialWindowFocus',
            'catchAllRoute',
            'showOrgSignup',
            'selectBufferByUrlWithText',
            'addNetwork', 'ircUrl',
            'feedback', 'joinEnterprise', 'openSettings'
        );

        this.router = new Backbone.Router();
        this.router.bind('route', this.model.onRoute, this.model);
        this.router.route('*catchAll', 'catchAllRoute', this.catchAllRoute);
        this.router.route('!/*networkString', 'selectBufferByUrl', _.bind(function (networkString) {
            return this.selectBufferByUrl(networkString, true);
        }, this));
        this.router.route('irc/*networkString', 'selectBufferByUrl', _.bind(this.selectBufferByUrl, this));
        this.router.route('?/irc_url=*ircUrl', 'ircUrl', this.ircUrl);
        this.router.route('?/text=:text&url=*networkString', 'selectBufferByUrlWithText', this.selectBufferByUrlWithText);

        options.router = this.router;

        // make router available on session, since it's already a "general" storage
        this.model.router = this.router;

        this.model.on('prefChange:time-24hr', this.renderDates, this);
        this.model.on('prefChange:time-seconds', this.renderDates, this);
        this.model.on('prefChange:layout-left', this.renderLayoutLeft, this);
        this.model.on('prefChange:theme', this.renderTheme, this);
        this.model.on('prefChange:theme-auto', this.renderTheme, this);
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', _.bind(function (e) {
            this.renderTheme();
        }, this));
        this.model.on('prefChange:font', this.renderFont, this);

        this.title = new TitleView(options);
        this.favicon = new FaviconView(options);

        this.status = new StatusView(options);

        this.mainArea = new MainAreaView(options);
        this.verifyNotice = new VerifyNoticeView(options);

        this.sidebar = new SidebarView(options);
        this.unsupported = $('#unsupported');

        this.pastebin = new PastebinDialogView(options);
        this.fileUploads = new FileUploadDialogView(options);
        this.logDownloads = new LogDownloadDialogView(options);
        this.shortcuts = new ShortcutsDialogView(options);
        this.files = new FilesDialogView(options);
        this.pastebins = new PastebinsDialogView(options);
        this.noAuthDialog = new NoAuthDialogView(options);
        if (this.model.ent()) {
            this.joinDefault = new EnterpriseJoinView(options);
        } else {
            this.joinDefault = new JoinDefaultView(options);
            this.upgrade = new UpgradeView(options);
            this.invites = new InvitesDialogView(options);
            this.orgs = new OrgsDialogView(options);
        }
        this.addSlackView = new AddSlackView(options);

        this.memberContextMenu = new MemberContextMenuView(options);
        this.channelContextMenu = new ChannelContextMenuView(options);
        this.conversationContextMenu = new ConversationContextMenuView(options);
        this.serverLogContextMenu = new ServerLogContextMenuView(options);
        this.uploadContextMenu = new UploadContextMenuView(options);
        this.emojiContextMenu = new EmojiContextMenuView(options);
        this.nickserv = new NickservView(options);
        this.connectionToken = new ConnectionTokenView(options);

        if (window.IRCConfig.postmark_rebound_public_key) {
            this.emailBounce = new EmailBounceView(options);
        }

        this.channelSwitcher = new ChannelSwitcher(options);
        this.$el.append(this.channelSwitcher.render().el);

        this.avatarUploadDialog = new AvatarUploadDialog(options);
        this.$el.append(this.avatarUploadDialog.render().el);

        this.avatarChooser = new AvatarChooserDialog(options);
        this.$el.append(this.avatarChooser.render().el);

        this.avatarUpload = new AvatarUploadView(options);
        this.$el.append(this.avatarUpload.render().el);

        this.model.on('change:session', this.renderAuth, this);
        this.model.on('change:limits', this.renderLimits, this);
        this.model.on('change:database_status', this.renderDbDown, this);
        this.model.on('systemMessage', this.systemMessage, this);
        this.model.on('init', this.init, this);
        this.model.on('currentBufferChange', this.currentBufferChange, this);
        this.model.on('startFallback', this.startFallback, this);
        this.model.on('hashDialogHide', this.hashDialogHide, this);
        this.model.on('navigate', this.navigate, this);
        this.model.on('noAuth', this.noAuth, this);

        this.model.on('sidebarBufferClick', this.sidebarBufferClick, this);
        this.model.on('clickedMessageDate', this.messageDateClick, this);
        this.model.on('clickedMessageReactAdd', this.messageReactAddClick, this);
        this.model.on('playAlert', this.playAlert, this);
        this.model.on('exportConfirm', this.exportConfirm, this);
        this.model.on('pasteConfirm', this.pasteConfirm, this);
        this.model.on('uploadConfirm', this.uploadConfirm, this);
        this.model.on('batchUploadConfirm', this.batchUploadConfirm, this);
        this.model.on('exportFinished', this.exportFinished, this);
        this.model.on('clickUpload', this.clickUpload, this);
        this.model.on('clickEmoji', this.clickEmoji, this);

        this.model.backend.on('stream:starting', this.connecting, this);
        this.model.on('doneLoading', this.doneLoading, this);
        this.model.on('streamConnectedChange', this.streamConnectedChange, this);
        this.model.backend.on('unsupported', this.showUnsupported, this);
        this.model.backend.on('xhrFallback', this.xhrFallback, this);

        this.model.connections.on('nickServPrompt', this.showNickServ, this);
        this.model.connections.on('showConnectionToken', this.showConnectionToken, this);
        this.model.on('currentConnectionUrlChange', this.resetUrl, this);
        this.model.on('threadChange', this.resetUrl, this);
        this.model.buffers.on('scrollMessageChange', this.resetUrl, this);

        this.model.on('bufferOptions', this.bufferOptions, this);

        this.styleSheets = {};
        this.model.on('addStyleSheet', this.addStyleSheet, this);

        // accept irc: and ircs: links
        this.registerProtocolHandlers();

        this.installFirefoxApp();

        // Browser hacks/workarounds/special casing
        this.operaLayoutHack();
        this.renderCmdKey();

        // Track focused state (for setting highlights in title)
        this.trackFocusState();

        // Web Notification, fluid and macgap
        this.notifier = new IRCCloudNotifier(this.model);

        this.trackPostMessages();
    },
    events: {
        'click .bufferLink.irc': 'clickIRCLink',
        'click .bufferLink.user, .avatar': 'clickUser',
        'buttonClick .bufferLink.user, .avatar': 'clickUser',
        'click .bufferLink.channel': 'clickChannel',
        'click .bufferLink.server': 'clickServer',
        'click span.date': 'clickDate',
        'click #xhrWarning a.dismiss': 'clickXhrWarningDismiss',
        'click .log .row .reaction': 'clickReaction',
        'mouseenter .bufferLink.user, .avatar': 'hoverUser',
        'mouseleave .bufferLink.user, .avatar': 'unhoverUser',
        'dragstart': 'dragStart',
        'dragover': 'dragOver',
        'dragleave': 'dragLeave',
        'drop': 'drop'
    },
    catchAllRoute: function () {
        this.startFallback();
    },
    dragStart: function (e) {
        var target = $(e.target);
        if (target.is('a.docLink')) {
            var downloadUrl = target.find('.documentIcon').data('DownloadURL');
            e.originalEvent.dataTransfer.setData('DownloadURL', downloadUrl);
        }
    },
    dragOver: function (e) {
        e.preventDefault();
        var dt = e.originalEvent.dataTransfer;
        if (dt && _.contains(dt.types, 'Files')) {
            dt.dropEffect = 'copy';
            if (!$('#dropTargetContainer').hasClass('visible')) {
                $('#dropTargetContainer').stop().fadeIn(50).addClass('visible');
            }
        }
        if (this.dragOverTimeout) {
            clearTimeout(this.dragOverTimeout);
        }
        this.dragOverTimeout = setTimeout(_.bind(this.fadeDropTarget, this), 1000);
    },
    fadeDropTarget: function (callback) {
        if ($('#dropTargetContainer').hasClass('visible')) {
            if (this.dragOverTimeout) {
                clearTimeout(this.dragOverTimeout);
            }
            this.dragOverTimeout = null;
            $('#dropTargetContainer').stop().fadeOut(200, function () {
                $('#dropTargetContainer').removeClass('visible');
                if (callback) {
                    callback();
                }
            });
        } else {
            if (callback) {
                callback();
            }
        }
    },
    dragLeave: function (e) {
        var dt = e.originalEvent.dataTransfer;
        if (dt && _.contains(dt.types, 'Files')) {
            if (e.originalEvent.pageX <= 0
             || e.originalEvent.pageX >= window.innerWidth
             || e.originalEvent.pageY <= 0
             || e.originalEvent.pageY >= window.innerHeight) {
                this.fadeDropTarget();
            }
        }
    },
    drop: function (e) {
        e.preventDefault();
        var current = this.model.currentBuffer;
        var threadTargets = atPoint(e.clientX, e.clientY, '#threadContainer', '#bufferPanes, div.timecell');
        if (threadTargets[0]) {
            current = this.mainArea.currentThread.model;
        }
        var dt = e.originalEvent.dataTransfer;
        var files, items, entries, url;
        if (dt) {
            url = dt.getData('URL');
            files = dt.files;
            items = dt.items;
            entries = FileWrapper.getEntries(dt);
        }
        if (this.dragOverTimeout) {
            clearTimeout(this.dragOverTimeout);
        }
        this.fadeDropTarget(_.bind(function () {
            if (current) {
                var options = {
                    dropped: true
                };
                if (e.shiftKey || e.altKey) {
                    options.immediate = true;
                }
                if (files && files.length) {
                    options.files = files;
                    options.entries = entries;
                    options.items = items;
                    current.trigger('upload', options);
                } else if (url) {
                    var blob = FileWrapper.blobFromDataURI(url);
                    if (blob) {
                        options.files = [blob];
                        current.trigger('upload', options);
                    } else {
                        current.trigger('insertAtCursor', url, true);
                    }
                } else if (items) {
                    _.each(items, function (item) {
                        if (item.kind == 'string' && item.type == 'text/plain') {
                            item.getAsString(_.bind(function (value) {
                                if (value) {
                                    current.trigger('insertAtCursor', value, true);
                                }
                            }, this));
                        }
                    }, this);
                }
            }
        }, this));
    },
    addStyleSheet: function (stylesheet, callback) {
        if (!this.styleSheets[stylesheet]) {
            debug.log('add stylesheet', stylesheet);
            var link = $('<link rel="stylesheet">').attr('href', stylesheet);
            link.on('load', _.bind(function () {
                if (callback) {
                    callback();
                }
            }, this));
            $('head').append(link);
            this.styleSheets[stylesheet] = true;
        } else {
            if (callback) {
                callback();
            }
        }
    },
    clickIRCLink: function (e) {
        var link = $(e.currentTarget);
        this.navigate(link.attr('data-url'), {trigger: true});
        return false;
    },
    clickChannel: function (e) {
        var link = $(e.currentTarget);
        var connection = this.model.getConnection(link.data('cid'));
        var channel = link.attr('data-name');
        if (link.hasClass('channelInviteLink')) {
            connection.joinChannel(channel);
        } else {
            connection.openBuffer(channel);
        }
        return false;
    },
    clickServer: function (e) {
        var link = $(e.currentTarget);
        var connection = this.model.getConnection(link.data('cid'));
        connection.select();
        return false;
    },
    eventUserEl: function (e) {
        var el = $(e.currentTarget);
        if (el.hasClass('hasUserParent')) {
            return el.closest('.userParent');
        }
        return el;
    },
    clickUser: function (e, options) {
        options = options || {};
        var link = this.eventUserEl(e);
        var connection = this.model.getConnection(link.data('cid'));
        if (connection) {
            var user = this.makeUserFromLink(link, connection);
            var x = e.pageX;
            var y = e.pageY;
            if ('x' in options) {
                x = options.x;
            }
            if ('y' in options) {
                y = options.y;
            }
            this.memberContextMenu.show(user, x, y);
        }
        return false;
    },
    clickReaction: function (e) {
        var reaction = $(e.currentTarget);
        if (!reaction.data('self')) {
            var connection = this.model.getConnection(reaction.data('cid'));
            if (connection) {
                var buffer = connection.getBuffer(reaction.data('bid'));
                if (buffer) {
                    buffer.react(reaction.data('msgid'), reaction.data('reaction'));
                }
            }
        }
        return false;
    },
    clickXhrWarningDismiss: function (e) {
        e.preventDefault();
        $('#xhrWarning').slideUp({
            duration: 'fast',
            progress: _.bind(function () {
                this.mainArea.currentBufferTopChange();
            }, this),
            complete: _.bind(function () {
                this.status.renderVisible();
                this.mainArea.currentBufferTopChange();
            }, this)
        });
    },
    hoverUser: function (e) {
        var link = this.eventUserEl(e);
        if (link.data('usermask')) {
            var connection = this.model.getConnection(link.data('cid'));
            if (connection) {
                var user = this.makeUserFromLink(link, connection);
                this.mainArea.highlightCurrentUserRows(user);
            }
        }
    },
    unhoverUser: function (e) {
        this.mainArea.unhighlightCurrentUserRows();
    },
    bufferOptions: function (button, buffer, e) {
        var menu;
        if (buffer.isChannel()) {
            menu = this.channelContextMenu;
        } else if (buffer.isConversation()) {
            menu = this.conversationContextMenu;
        } else if (buffer.isServerLog()) {
            menu = this.serverLogContextMenu;
        }
        if (menu.isVisible() && buffer.equals(menu.buffer)) {
            menu.hide();
        } else {
            this.channelContextMenu.hide();
            this.conversationContextMenu.hide();
            this.serverLogContextMenu.hide();
            menu.show(buffer, button, {
                keypress: Keyboard.isClickEnter(e)
            });
        }
    },
    clickUpload: function (e, buffer) {
        var menu = this.uploadContextMenu;
        if (menu.isVisible()) {
            menu.hide();
        } else {
            var cell = $(e.currentTarget);
            menu.show(buffer, cell);
        }
    },
    clickEmoji: function (e, buffer) {
        var menu = this.emojiContextMenu;
        var cell = $(e.currentTarget);
        if (cell.is(menu.triggerEl) && menu.isVisible()) {
            menu.hide();
        } else {
            menu.show(buffer, cell);
        }

    },
    pasteConfirm: function (buffer, options, onCancel) {
        this.pastebin.show(buffer, options, onCancel);
    },
    uploadConfirm: function (fileView, buffer, options, onConfirm, onCancel) {
        this.fileUploads.showSingle(fileView, buffer, options, onConfirm, onCancel);
    },
    batchUploadConfirm: function (fileTreeView, buffer, options, onConfirm, onCancel) {
        this.fileUploads.showBatch(fileTreeView, buffer, options, onConfirm, onCancel);
    },
    exportConfirm: function (model) {
        this.logDownloads.show(model);
        return false;
    },
    exportFinished: function (message) {
        if (!this.logDownloads.isVisible()) {
            this.mainArea.renderCurrentOverlay(this.logDownloads.finishedOverlay(message));
        }
    },
    trackFocusState: function () {
        $(window).blur(this.windowBlur);
        $(window).focus(this.windowFocus);
        if ('hasFocus' in document) {
            this.model.setFocused(document.hasFocus());
        } else {
            $(window).on('click mousemove keydown keypress', this.initialWindowFocus);
        }
    },
    trackPostMessages: function () {
        $(window).on('message', _.bind(function (e) {
            this.model.addPostMessage(e.originalEvent);
            this.trigger('postMessage', e.originalEvent);
        }, this));
    },
    registerProtocolHandlers: function () {
        if (window.navigator.registerProtocolHandler) {
            try {
                window.navigator.registerProtocolHandler('irc', '/?/irc_url=%s', 'IRCCloud');
                window.navigator.registerProtocolHandler('ircs', '/?/irc_url=%s', 'IRCCloud');
            } catch (e) {
                // Browser can throw a security error if the protocol isn't allowed
            }
        }
    },
    installFirefoxApp: function () {
        if (this.model.featureCheck('mozApps') && window.navigator.mozApps) {
            // TODO check if already installed
            // TODO check if already prompted
            // https://developer.mozilla.org/en-US/docs/Web/API/Apps.checkInstalled
            try {
                var request = window.navigator.mozApps.install(this.model.getOrigin() + '/manifest.webapp');
                request.onsuccess = function () {
                    debug.log('mozApps install success', this);
                };
                request.onerror = function () {
                    debug.warn('mozApps install error', this.error.name, this.error.message);
                };
            } catch (e) {
                debug.warn('mozApps install exception', e);
            }
        }
    },
    operaLayoutHack: function () {
        if ($.browser.opera) {
            $(this.el).css('overflow', 'visible');
        }
    },
    renderCmdKey: function () {
        $('.kbd__cmd').text(Keyboard.modifierName()).attr('aria-label', Keyboard.modifierLabel());
    },
    sidebarBufferClick: function (buffer) {
        if (buffer.hasUnseenHighlights()) {
            IRCCloudNotifier.requestPermission(_.bind(function (permission) {
                this.trigger('notificationPermissionRequested', permission);
            }, this));
        }
    },
    messageDateClick: function (message) {
        this.lastClickedMessage = message;
        if (this.lastClickedMessage) {
            debug.info(
                'Clicked row: [' +
                this.lastClickedMessage.get('type') +
                '] ' + this.lastClickedMessage.id
            );
        }
    },
    messageReactAddClick: function (message, el) {
        if (message.isReactable()) {
            this.emojiContextMenu.show(message.buffer, el, {
                action: 'reactMessageEmoji',
                actionData: {
                    message: message
                },
                reaction: true
            });
        }
    },
    notify: function (buffer, options) {
        if (!window.CHROME_EXTENSION) {
            this.playAlert();
            this.notifier.notify(options);
        }
    },
    sounds: {},
    setupAudio: function (onReady) {
        if (!this.audioSetup) {
            this.sounds.alert = $('<audio>')
                .append($('<source>').attr({
                    src: '/static/digit.mp3',
                    type: "audio/mpeg"
                }))
                .append($('<source>').attr({
                    src: '/static/digit.ogg',
                    type: 'audio/ogg'
                }))[0];
            this.audioSetup = true;
        }
        if (onReady) {
            onReady();
        }
    },
    play: function (sound, force) {
        if (force || this.alertsEnabled()) {
            this.setupAudio(_.bind(function () {
                this.sounds[sound].play();
            }, this));
        }
    },
    playAlert: function (force) {
        this.play('alert', force);
    },
    alertsEnabled: function () {
        return !this.model.getPref('notifications-disableaudio');
    },
    renderPrefs: function () {
        $(this.el).toggleClass('time-12hr', !this.model.getPref('time-24hr'));
        $(this.el).toggleClass('time-24hr', !!this.model.getPref('time-24hr'));
        $(this.el).toggleClass('time-seconds', !!this.model.getPref('time-seconds'));
        $(this.el).toggleClass('time-noseconds', !this.model.getPref('time-seconds'));
        this.mainArea.timeLayoutChange();
        $(this.el).toggleClass('mode-hidesymbol', !this.model.getPref('mode-showsymbol'));
        $(this.el).toggleClass('nick-colors', !!this.model.getPref('nick-colors'));
        $(this.el).toggleClass('mention-colors', !!this.model.getPref('mention-colors'));
        $(this.el).toggleClass('ascii-compact', !!this.model.getPref('ascii-compact'));
        $(this.el).toggleClass('emoji-convert', !this.model.getPref('emoji-disableconvert'));
        $(this.el).toggleClass('emoji-disableconvert', !!this.model.getPref('emoji-disableconvert'));
        $(this.el).toggleClass('emoji-big', !this.model.getPref('emoji-nobig'));
        this.renderValentine();
        if (this.alertsEnabled()) {
            this.setupAudio();
        }
        this.mainArea.currentBufferTopChange();
    },
    renderedTheme: null,
    renderTheme: function () {
        if (this.renderedTheme) {
            this.$el.removeClass('theme-' + this.renderedTheme);
        }
        this.$el.removeClass('themeShade-light');
        this.$el.removeClass('themeShade-dark');
        var theme = this.model.getTheme();
        this.$el.addClass('theme-' + theme);
        this.renderedTheme = theme;
        if (this.model.isLightTheme()) {
            this.$el.addClass('themeShade-light');
            $('#twitterMetaTheme').attr('content', '');
        } else {
            this.$el.addClass('themeShade-dark');
            $('#twitterMetaTheme').attr('content', 'dark');
        }
    },
    renderFont: function (prevFont) {
        if (prevFont) {
            this.$el.removeClass('font-' + prevFont);
        }
        this.$el.addClass('font-' + this.model.getFont());
    },
    renderDates: function () {
        $('.messageRow').each(function () {
            var row = $(this);
            var date = new Date(row.data('time'));
            var dateSpan = row.find('span.date .timestamp');
            dateSpan.attr('title', date.formatFullDate()).text(date.formatTime());
        });
    },
    renderLayoutLeft: function () {
        $(this.el).toggleClass('left', !!this.model.getPref('layout-left'));
    },
    renderValentine: function () {
        var toggle;
        var today = new Date();
        if (today.getDate() == 14 && today.getMonth() == 1) {
            toggle = true;
        } else {
            toggle = !!this.model.getPref('valentine');
        }
        $(this.el).toggleClass('valentine', toggle);
    },
    showNickServ: function (connection) {
        this.nickserv.show(connection);
    },
    showConnectionToken: function (connection) {
        this.connectionToken.show(connection);
    },
    showOrgSignup: function (inviteKey, email, orgName) {
        if (this.model.isAuthed()) {
            this.orgs.showJoin(inviteKey, orgName);
        } else {
            this.noAuthDialog.fillOrgSignup(inviteKey, email, orgName);
        }
    },
    xhrFallback: function () {
        $(this.el).addClass('xhr');
        if (!this.model.featureCheck('websockets')) {
            $(this.el).addClass('xhrOnly');
        }
    },
    renderDbDown: function () {
        $(this.el).toggleClass('dbDown', this.model.isDbDown());
        this.status.renderVisible();
    },
    showUnsupported: function () {
        this.unsupported.fadeIn('fast');
    },
    initialWindowFocus: function (e) {
        // Force focus on initial mouse/key action
        if (e.type == 'mousemove' && e.pageX === 0 && e.pageY === 0) {
            // Erroneous initial mousemove
            return;
        }
        $(window).off('click mousemove keydown keypress', this.initialWindowFocus);
        this.model.setFocused(true);
    },
    makeUserFromLink: function (link, connection) {
        var buffer = connection.getBuffer(link.attr('data-bid'));
        if (buffer) {
            var message = buffer.getMessage(link.attr('data-eid'));
            if (message) {
                return message.makeUser(link.attr('data-name'));
            }
        }
        var data = link[0].dataset;
        var user = connection.makeUserFromTarget(
            data.bid,
            _.extend({}, data, {
                nick: data.name,
                hostmask: data.usermask,
                from_name: data.user,
                from_host: data.userhost,
                from_mode: data.mode,
                from_account: data.account,
                from_realname: data.realname
            })
        );
        return user;
    },
    navigate: function (url, options) {
        if (url.indexOf('/irc/') === 0 && this.model.threadId) {
            url += '/thread/' + encodeURIComponent(this.model.threadId);
        }
        this.router.navigate(url, options);
    },
    noAuth: function () {
        this.start();
        this.currentBufferChange();
    },
    hashDialogHide: function () {
        if (!this.model.isAuthed()) {
            this.model.back();
            this.noAuthDialog.show();
            return;
        } else {
            this.currentBufferChange();
        }
    },
    resetUrl: function () {
        this.navigate(this.model.currentBuffer.url(), {replace: true});
    },
    currentBufferChange: function (options) {
        options = options || {};
        if (!this.model.isAuthed()) {
            this.noAuthDialog.show();
            return;
        }
        this.hideContextMenus();

        if (this.model.currentBuffer) {
            // Make sure addNetwork is hidden
            HashDialogView.closeCurrent();
            this.hideJoinDefault();
            this.hideAddNetwork();
            this.hideSettings({silent: true});
            try {
                this.navigate(this.model.currentBuffer.url(), {replace: !!options.replace});
            } catch (exc) {
                // pass this can error
                debug.warn('navigation failed', this.model.currentBuffer.url(), exc);
            }
        } else if (options.cleared || !this.selectLastSelectedBuffer()) {
            this.model.clearCurrentBuffer(true); // silent so we don't end up in a loop
            if (this.model.ent() && !this.model.hasConnections() && this.model.hasAutojoin()) {
                this.navigate('?/join');
                this.showJoinDefault();
            } else {
                this.navigate('?/addNetwork');
                this.showAddNetwork();
            }
        }
    },
    start: function () {
        if (this.started) {
            return Backbone.history.loadUrl();
        }

        if (!this.model.ent()) {
            this.router.route('?/team-invite=:key&email=:email&team=*name', 'showOrgSignup', this.showOrgSignup);
        }

        this.started = true;

        var pushState = true;
        if (this.model.featureCheck('disablePushState')) {
            pushState = false;
        }
        return Backbone.history.start({pushState: pushState});
    },
    init: function () {
        this.renderTheme();
        this.renderFont();
        this.renderPrefs();
        this.renderAuth();
        this.renderDbDown();
        this.model.bind('prefChange', this.renderPrefs, this);
        this.model.bind('featureChange', this.renderPrefs, this);
        this.model.bind('notify', this.notify, this);

        this.router.route('?/addNetwork', 'addNetwork', this.addNetwork);
        if (this.model.ent()) {
            this.router.route('?/join', 'joinEnterprise', this.joinEnterprise);
        } else {
            this.router.route('?/feedback', 'feedback', this.feedback);
        }
        this.router.route('?/settings', 'openSettings', this.openSettings);
        this.router.route('?/settings=*section', 'openSettings', this.openSettings);

        this.start();
    },
    startFallback: function () {
        // No route detected, select the last_selected_bid
        if (!this.selectLastSelectedBuffer()) {
            this.currentBufferChange();
        }
    },
    selectLastSelectedBuffer: function () {
        var buffer = this.model.getLastSelectedBuffer();
        if (buffer) {
            buffer.select();
            return true;
        }
        return false;
    },
    connecting: function () {
        $(this.el).addClass('connecting');
    },
    streamConnectedChange: function () {
        if (this.model.isStreamConnected()) {
            this.mainArea.showBuffers();
            $(this.el).removeClass('connecting');
            $(this.el).removeClass('disconnected');
            $(this.el).addClass('loading');
        } else if (!this.model.backend.unloading) {
            $(this.el).removeClass('connecting');
        }
    },
    doneLoading: function () {
        $(this.el).removeClass('loading');
    },

    systemMessage: function (message) {
        var msg = message.msg;
        if (message.system_message_type == 'refresh') {
            msg = $('<span>');
            msg.append("IRCCloud has been updated. ");
            msg.append($('<a href="#">').text('Refresh the page').click(function (e) {
                window.location.reload();
            }));
            msg.append(" to get the latest version.");
        }
        var content = $('<p>').append(msg);
        var head;
        if (message.time && message.time > 0) {
            var date = new Date(message.time * 1000);
            head = date.formatFullDate();
        }
        var overlay = new Overlay(content, {
            doneText: 'Close',
            message: message,
            head: head
        });
        this.mainArea.renderCurrentOverlay(overlay);
    },
    renderAuth: function () {
        $(this.el).toggleClass('authed', this.model.isAuthed());
        if (this.model.isInitialized()) {
            $(this.el).addClass('init');
        }
    },
    renderLimits: function () {
        $(this.el).toggleClass(
            'passwordedServersAllowed',
            this.model.arePasswordedServersAllowed()
        );
    },
    windowBlur: function (e) {
        this.model.setFocused(false);
    },
    windowFocus: function (e) {
        this.model.setFocused(true);
    },
    ircUrl: function (ircUrl, options) {
        options = options || {};
        var navOpts = {};
        if (options.replace !== false) {
            navOpts.replace = true;
        }
        navOpts.trigger = true;
        var parts = util.ircUrlParts(decodeURIComponent(ircUrl));
        if (parts) {
            this.navigate('irc/' + parts.url, navOpts);
        } else {
            this.currentBufferChange();
        }
    },
    hideContextMenus: function () {
        this.memberContextMenu.hide();
        this.emojiContextMenu.hide();
        this.channelContextMenu.hide();
        this.conversationContextMenu.hide();
        this.serverLogContextMenu.hide();
    },
    clearForNonBufferUrl: function () {
        this.hideContextMenus();
        this.model.clearCurrentBuffer(true); // silent so we don't change the url
        this.mainArea.clearCurrent();
    },
    joinEnterprise: function () {
        this.clearForNonBufferUrl();
        this.showJoinDefault();
    },
    openSettings: function (section) {
        if (!section) {
            section = this.mainArea.settings.defaultSection;
            this.router.navigate('?/settings=' + section, {replace: true});
        }
        this.showSettings(section);
    },
    feedback: function () {
        var found, lastC;
        var channelName = '#feedback';
        _.each(this.model.connections.where({'hostname': 'irc.irccloud.com'}), _.bind(function (c) {
            var buffer = c.findChannel(channelName);
            if (buffer) {
                found = true;
                this.navigate(buffer.url(), {replace: true});
                c.joinChannel(channelName);
            }
            lastC = c;
        }, this));
        if (!found) {
            if (lastC) {
                var b = lastC.openBuffer(channelName);
                this.navigate(b.url(), {replace: true});
                lastC.joinChannel(channelName);
            } else {
                this.clearForNonBufferUrl();
                this.showJoinDefault();
            }
        }
    },
    addNetwork: function (networkId) {
        this.clearForNonBufferUrl();
        this.showAddNetwork(util.getBufferParts(networkId));
    },
    selectBufferByUrlWithText: function (text, networkId) {
        var buffer = this.selectBufferByUrl(networkId, true);
        if (buffer && buffer.bid()) {
            buffer.trigger('setInputText', text);
        }
    },
    selectBufferByUrl: function (networkId, forceNavigate) {
        if (this.model.isAuthed()) {
            var bufferParts = util.getBufferParts(networkId);
            var connection;
            if (bufferParts) {
                this.model.setThreadId(bufferParts.thread, {silent: true});
                // Lookup the connection in our fuzzy map
                connection = this.model.getConnectionById(bufferParts.connectionId) || this.model.getConnectionById(bufferParts.hostname);
            }
            if (!connection || !bufferParts.buffer) {
                var legacyBufferParts = util.getBufferPartsLegacy(
                    networkId, Backbone.history.getHash()
                );
                if (legacyBufferParts) {
                    bufferParts = legacyBufferParts;
                    // Lookup the connection in our fuzzy map
                    connection = this.model.getConnectionById(bufferParts.connectionId) || this.model.getConnectionById(bufferParts.hostname);
                }
            }
            if (connection) {
                var buffer;
                var newBuffer;
                if (bufferParts.buffer) {
                    var bufferName = bufferParts.buffer;
                    if (
                        bufferParts.type == 'channel' &&
                        !connection.isChannelName(bufferName)
                    ) {
                        bufferName = '#' + bufferName;
                    }
                    buffer = connection.findBuffer(bufferName);
                    if (!buffer) {
                        newBuffer = bufferName;
                        buffer = connection.serverLog;
                    }
                } else {
                    buffer = connection.serverLog;
                }
                if (buffer) {
                    HashDialogView.closeCurrent();
                    buffer.select({replace: true});
                }
                if (newBuffer) {
                    buffer = connection.openNewBuffer(newBuffer);
                }
                if (buffer && (forceNavigate || (buffer.urlId() != networkId) || this.model.threadId)) {
                    this.navigate(buffer.url(), {replace: true});
                }
                return buffer;
            } else {
                this.hideContextMenus();
                this.navigate('?/addNetwork', {replace: true});
                this.showAddNetwork(bufferParts);
                this.model.clearCurrentBuffer();
            }
        }
    },
    showJoinDefault: function () {
        HashDialogView.closeCurrent();
        this.hideAddNetwork();
        this.hideSettings({silent: true});
        this.joinDefault.show();
    },
    hideJoinDefault: function () {
        this.joinDefault.hide();
    },
    showAddNetwork: function (bufferParts) {
        HashDialogView.closeCurrent();
        this.hideJoinDefault();
        this.hideSettings({silent: true});
        this.mainArea.addNetwork.show(bufferParts);
    },
    hideAddNetwork: function () {
        this.mainArea.addNetwork.hide();
    },
    showSettings: function (section) {
        HashDialogView.closeCurrent();
        this.clearForNonBufferUrl();
        this.hideJoinDefault();
        this.hideAddNetwork();
        this.mainArea.settings.show(section);
    },
    hideSettings: function (options) {
        this.mainArea.settings.hide(options);
    }
});

module.exports = SessionView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/sessionview.js
// module id = ycye
// module chunks = 1